// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2W6jC","rootSmall":"AddTileButton_rootSmall__2n5WQ"};